import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { I18nModule } from '@spartacus/core';
import { CustomProfileService } from 'src/app/core/services/custom-profile.service';
import { InvoiceDetailsResponse, InvoiceDocument } from './attach-invoice.interface';
import { ToastrService } from 'ngx-toastr';
import { FileUploader, FileUploadModule } from 'ng2-file-upload';
import { PortInvoiceComponent } from '../port-invoice/port-invoice.component';
import  moment from 'moment' 

@Component({
  selector: 'app-attach-invoice',
  imports: [CommonModule, I18nModule, FileUploadModule, FormsModule],
  templateUrl: './attach-invoice.component.html',
  styleUrls: ['./attach-invoice.component.scss'],
})
export class AttachInvoiceComponent implements OnInit {
  @Input() display: any;
  @Input() batchData: any;
  @Input() useCaseType: 'SCREENINGINVOICE_UC3' | 'CARGOARRIVALINVOICE_UC3' | 'CARGODELIVERYINVOICE_UC3' | 'PORTARRIVALINVOICE_UC3' = 'SCREENINGINVOICE_UC3';
  @Input() nominationData: any;
  @Input() fromPortInvoice : boolean = false;
  @Input() portInvoiceAction: 'VIEW' | 'ADD' = 'ADD';
  @Input() addedInvoices: any[] = [];
  maxFileSizeInBytes = 10 * 1024 * 1024;
  uploadedInvoices: any[] = [];
  existingInvoiceDocs: InvoiceDocument[] = [];
  invoiceResponse: InvoiceDetailsResponse | null = null;
  validationMessage = '';
  enableLoader: boolean = false;
  createSES: boolean = false;
  isValidating: boolean = false;
  showConfirmation: boolean = false;
  showReValidate: boolean = false;
  azureResponse: string = '';
  revalidateClicked: boolean = false;
  azureShowStatus: string = '';
  transformedDate: string = '';
   fileArray: any[] = [];
  filesTopushForCall: any[] = []; 
  base64: any;
  filesLength: any;
  showRevalidateButton: boolean = false;
  showReload: boolean = false;
  signatures: any = {
    JVBERi0: 'application/pdf',
    R0lGODdh: 'image/gif',
    R0lGODlh: 'image/gif',
    iVBORw0KGgo: 'image/png',
    '/9j/': 'image/jpg',
  };
  htmlOutput: string = '';
  invoiceTypeOptions: any[] = [];
  selectedInvoiceType: string = '';
  systemSubType: string = '';
  constructor(
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private customProfileService: CustomProfileService,
    private cd: ChangeDetectorRef,
        private toastrService: ToastrService,
       
  ) { 
     
  }

  ngOnInit(): void {
    this.getInvoiceDetails();
    this.validationMessage = 'Validation results and any error details will appear here.';
  }
onInvoiceTypeChange(event: Event): void {
  const newValue = (event.target as HTMLSelectElement)?.value || '';
  
  if(this.portInvoiceAction == 'VIEW'){
    // Check if the selected invoice type is already added
    const isDuplicate = this.addedInvoices.some((item: any) => 
      item.subtype.includes(newValue)
    );
    
    if (isDuplicate) {
      this.toastrService.show('Duplicate invoice type selected: ' + newValue + '. Cannot add duplicate invoice types.');
      // Revert to previous value by explicitly setting it
      setTimeout(() => {
        this.selectedInvoiceType = this.invoiceResponse?.invoiceType || '';
        this.cd.detectChanges();
      }, 0);
      return;
    }
  }
  
  this.selectedInvoiceType = newValue;
  console.log('selectedInvoiceType dropdown changed to:', this.selectedInvoiceType);
}
getDropDownList() {
      const isScreening = this.useCaseType === 'SCREENINGINVOICE_UC3';
  const invTypeListObv = isScreening
    ? this.customProfileService.screeningInvTypeListObv
    : this.customProfileService.portInvTypeListObv;
   invTypeListObv.subscribe(res => {
      if (res && res?.length) {
        this.invoiceTypeOptions = res.map((items: any) => ({
          label: items.name,
          value: items.code,
          allowMultiple: items.allowMultiple
        }));
        this.preSelectInvoiceType();
      } else {
        this.customProfileService.getMasterData().subscribe({
          next: (response: any) => {
            const masterDataList = isScreening
              ? response.screeningInvTypeList
              : response.portInvTypeList;
            if (isScreening) {
              this.customProfileService.setScreeningInvoiceTypes(masterDataList);
            } else {
              this.customProfileService.setPortInvoiceTypes(masterDataList);
            }
            this.invoiceTypeOptions = masterDataList?.map((item: any) => ({
              label: item.name,
              value: item.code,
              allowMultiple: item.allowMultiple
            }));
            this.preSelectInvoiceType();
          }
        });
      }
    }); 
}

private preSelectInvoiceType(): void {
  if (this.invoiceTypeOptions.length) {
    const matchedOption = this.invoiceTypeOptions.find(opt => opt?.value === this.invoiceResponse?.invoiceType);
    if (matchedOption) {
      this.selectedInvoiceType = matchedOption.value;
      this.cd.detectChanges();
    } else {
      console.log('No matching option found for invoiceType:', this.invoiceResponse?.invoiceType, 'availableOptions:', this.invoiceTypeOptions);
    }
  } else {
    console.log('Cannot pre-select: invoiceType=', this.invoiceResponse?.invoiceType, 'optionsLength=', this.invoiceTypeOptions.length);
  }
}
  onClose(): void {
    this.activeModal.dismiss('close');
  }

  onCancel(): void {
    this.activeModal.dismiss('cancel');
  }

  onNext(): void {
    this.showConfirmation = true;
  }

  onBack(): void {
    if (this.fromPortInvoice ) {
      this.activeModal.dismiss('back');

        const modalref = this.modalService.open(PortInvoiceComponent, {
          centered: true,
          size: 'lg',
          backdrop: 'static',
          keyboard: false,
        });
        modalref.componentInstance.display = this.display;
        const backBatchData = { ...(this.batchData || {}) };
        delete backBatchData.systemSubType;
        modalref.componentInstance.useCaseType = this.useCaseType;
        modalref.componentInstance.batchData = backBatchData;
        return;
    }
    
    this.showConfirmation = false;
  }

  onValidate(): void {
      this.isValidating = true;
      this.onSave(false);
  }

  onRevalidateClick(): void {
    this.isValidating = true;
    this.showRevalidateButton = false;
    this.onSave(false);
  }

  onReload(): void {
    this.enableLoader = true;
    this.getInvoiceDetails();
  }

  onSave(action: boolean = false): void {
    if (this.fromPortInvoice) {
      this.restrictDuplicateInvoices(action);
    }
    else {
      this.saveInvoice(action);
    }
  }

 public uploader: FileUploader = new FileUploader({
      url: ``,
      disableMultipart: false,
      autoUpload: true,
      method: 'post',
      itemAlias: 'attachment',
      allowedFileType: ['xls', 'xlsx', 'pdf', 'jpeg', 'png'],
      maxFileSize: 10485760,
    });
   onDragOver(event: any) {
      if(this.invoiceResponse?.sesShowStatus ==='Success'){
      return;
    }
    event.preventDefault();
  }

  onDropSuccess(event: any) {
     if(this.invoiceResponse?.sesShowStatus ==='Success'){
      return;
    }
    event.preventDefault();

    this.onFileChange(event.dataTransfer.files);
  }
 onChange(event: any) {
  
    this.onFileChange(event)
  }
   private onFileChange(event: any) {
    this.filesLength = event.length;
    const file: File = event[0];
    if (!file) {
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {

      this.base64 = reader.result
      const words = this.base64.split(',')[1]
      const filedata = {
        fileInBase64: words,
        mime: file.type,
        name: file.name,
        size: file.size.toString(),
      }
      let fileformatmessage = '';
      let fileexceedmsg = ''
      if ((filedata.mime == 'application/pdf' || filedata.mime == 'image/jpeg' || filedata.mime == 'image/png'
        || filedata.mime == 'application/vnd.ms-excel' || filedata.mime == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') && file.size < 10485760) {
        this.fileArray.push(filedata);
        this.filesTopushForCall.push(filedata);
        this.uploadedInvoices.push(file);
      }
      else if (filedata.mime != 'application/pdf' && filedata.mime != 'application/jpeg' && filedata.mime != 'image/pdf' && filedata.mime != 'image/png' && filedata.mime != 'application/vnd.ms-excel' && filedata.mime != 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        this.toastrService.show('Only PDF, JPEG and excel file formats are allowed');
      }
      else if (file.size > 10485760) {
        this.toastrService.show('File size no more than 10MB');
      }

    }
    reader.readAsDataURL(file);
  }
    private isAllowedType(fileType: string): boolean {
    const allowedTypes = ['application/pdf', 'image/jpg', 'image/jpeg', 'image/png'];
    return allowedTypes.includes(fileType);
  }
    private handleFileList(files: FileList): void {
    for (let i = 0; i < files.length; i++) {
      const file = files.item(i);
      if (!file) {
        continue;
      }

      if (!this.isAllowedType(file.type)) {
        this.validationMessage = 'Only PDF, JPG, JPEG or PNG files are allowed.';
        continue;
      }

      if (file.size > this.maxFileSizeInBytes) {
        this.validationMessage = 'File size no more than 10MB.';
        continue;
      }

      this.fileArray.push(file);
      this.uploadedInvoices.push(file);
      this.validationMessage = 'Validation results and any error details will appear here.';
    }
  }
   onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files?.length) {
      return;
    }

    this.handleFileList(input.files);
    input.value = '';
  }
    removeInvoice(index: number): void {
    this.uploadedInvoices.splice(index, 1);
    this.filesTopushForCall.splice(index, 1);
  }
private fileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const result = String(reader.result || '');
        const base64 = result.includes(',') ? result.split(',')[1] : result;
        resolve(base64);
      };
      reader.onerror = () => reject(reader.error);
      reader.readAsDataURL(file);
    });
  }
 private async buildValidationResponsePayload(): Promise<any> {
    const attachments = await Promise.all(
      this.uploadedInvoices.map(async file => {
        const base64 = await this.fileToBase64(file);
        return {
          fileInBase64: file.name,
          fileType: file.type,
          mime: base64,
          size: String(file.size),
        };
      })
    );
    return {
      externalNumber: this.batchData?.vatInvoiceNo || this.invoiceResponse?.externalNumber || '',
      purchaseOrderNumber: this.batchData?.purchaseOrderNo || this.invoiceResponse?.purchaseOrderNumber || '',
      itemCharge: this.batchData?.itemCharge || this.invoiceResponse?.itemCharge || '',
      grossPrice: this.batchData?.totalAmount || this.invoiceResponse?.grossPrice || '',
      nominationNumber: this.batchData?.nomination || this.batchData?.nominationNumber || '',
      nominationItemNumber: this.batchData?.nominationKeyItem || this.batchData?.nominationItemNumber || '',
      nominationKey: this.batchData?.nominationKey || '',
      batchId: this.batchData?.formattedNominationNumber || this.batchData?.batchId || '',
      baseProduct: this.batchData?.baseProduct || this.batchData?.baseProductCode || '',
      sesNumber: this.batchData?.sesNumber || this.invoiceResponse?.sesNumber || '',
      postingDate: this.batchData?.invoiceDate || this.invoiceResponse?.postingDate || '',
      useCaseType: this.useCaseType,
      attachments,
    };
  }

  private saveInvoice(action:boolean =false): void {
  
  this.enableLoader = true;
    const payload = {
      externalNumber: this.invoiceResponse?.externalNumber || '',
      purchaseOrderNumber: this.invoiceResponse?.purchaseOrderNumber || '',
      itemCharge: this.invoiceResponse?.itemCharge || '',
      grossPrice: this.invoiceResponse?.grossPrice || '',
      totalValue: this.invoiceResponse?.grossPriceInclTax || '',
      nominationNumber: this.batchData?.nominationNumber,
      nominationItemNumber: this.batchData?.nominationItemNumber,
      nominationKey: this.batchData?.nominationKey,
      batchId: this.batchData?.code,
      sesNumber:
      this.batchData?.sesNumber || this.invoiceResponse?.sesNumber || '',
      postingDate:this.batchData?.invoiceDate || this.invoiceResponse?.postingDate || '',
      useCaseType: this.useCaseType,
      attachments: this.filesTopushForCall,
      //to be sent as true alway, as per commerce requirement 
      isSesTriggered: true,
      ...(this.fromPortInvoice && {
        customerInvSubtype: this.selectedInvoiceType,
        systemInvSubtype: this.systemSubType
      })
    };
  //  this.buildValidationResponsePayload().then(payload => {
  this.customProfileService.saveInvoice('bhp', payload).subscribe({
    next: (res) => {
      this.enableLoader = false;
      if (res?.status === 'SUCCESS') {
        this.systemSubType = res.invoiceSubType;
        console.log('saveInvoice response:', res);
        this.toastrService.show('Invoice saved successfully.');
        if (!this.isValidating) {
          this.activeModal.close({ action: 'save' });
        } else {
          this.isValidating = false;
        }
      } else {
        this.toastrService.show(res?.message || 'Failed to save invoice.');
      }
      if(!action){
        this.validateInvoiceDetails();
      }
      
    },
    error: () => {
      this.enableLoader = false;
      this.toastrService.show('Failed to save invoice. Please try again.');
    },
  });
  // });
  }
   private validateInvoiceDetails(): void {
     const validateRequest = {
      nomination: this.batchData?.nomination || this.batchData?.nominationNumber,
      nominationKey: this.batchData?.nominationKey,
      nominationKeyItem: this.batchData?.nominationKeyItem || this.batchData?.nominationItemNumber,
      batchId: this.batchData?.code || this.batchData?.code,
       ...(this.fromPortInvoice && {
        sysSubType: this.systemSubType
      })
    };

    if ( !validateRequest.batchId && (
      !validateRequest.nomination ||
      !validateRequest.nominationKey ||
      !validateRequest.nominationKeyItem
    )) {
      this.toastrService.show('Unable to validate records. Missing nomination details.');
      return;
    }

   
    this.enableLoader = true;
    this.cd.detectChanges(); // Ensure UI updates before API call
    // const type = this.useCaseType;
     this.customProfileService.validateRecordPickup(validateRequest, this.useCaseType).subscribe(
      (res) => {
        this.validationMessage = 'Invoice details validated successfully.';
        this.isValidating = false;
        this.enableLoader = false;
        this.getInvoiceDetails();
      },
      (error) => {
        this.isValidating = false;
        this.enableLoader = false;
        this.toastrService.show('Validation failed.');
        this.getInvoiceDetails();
      },
      
    );
  }
 getInvoiceDetails(): void {
    const payload = this.buildInvoiceDetailsPayload();
    if (!payload.batchId && (!payload.nomination || !payload.nominationKey || !payload.nominationKeyItem)) {
      this.validationMessage = 'Validation results and any error details will appear here.';
      return;
    }
    const useCaseType = this.useCaseType ;
    this.enableLoader = true;
     this.filesTopushForCall = [];
     this.customProfileService.getInvoiceDetails(payload, this.useCaseType).subscribe({
      next: (response: InvoiceDetailsResponse) => {
        console.log('Invoice details response:', response);
        this.enableLoader = false;
        this.invoiceResponse = response || null;
        this.enableLoader = false;
        this.azureResponse = response?.azureResponse || '';
        this.htmlOutput = this.azureResponse? this.azureResponse.split('| ').map(sentence => `<p>${sentence}</p>`).join('') : '';
        this.showRevalidateButton = (response?.azureStatus || '').toLowerCase() === 'failure';
       if(response?.azureStatus?.toLowerCase() === 'in_progress'){
      this.showReload = true;
      if(response?.triggerTimeStamp){
        const currentTime = new Date();
        const validationTime = new Date(response?.triggerTimeStamp);
        const timeDifference = Math.abs(currentTime.getTime() - validationTime.getTime());
        const minutesDifference = timeDifference / 1000;
        console.log('difference',minutesDifference)
        if (minutesDifference > response?.timeoutSeconds) {
          this.showRevalidateButton = true;
        }else{
          this.showRevalidateButton = false;
        }
      }
    }
        this.uploadedInvoices = this.invoiceResponse.invoiceDocs || [];
        this.transformedDate = this.invoiceResponse?.postingDate? this.transformDate(this.invoiceResponse?.postingDate):''
        if (
          this.invoiceResponse.invoiceDocs &&
          this.invoiceResponse.invoiceDocs.length >= 1
        ) {
          this.invoiceResponse.invoiceDocs.forEach((e) => {
            let mimeType = this.detectMimeType(e.base64);
            console.log(mimeType, 'mimeType');
            this.filesTopushForCall.push({
              fileInBase64: e.base64,
              mime: mimeType,
              name: e.documentName,
              size: e.size,
              downloadURL: e.downloadURL,
            });
          });
        }
         if (this.fromPortInvoice) {
           this.getDropDownList();
         }
      },
      error: () => {
        this.validationMessage = 'Unable to validate invoice details. Please try again.';
      }
    });
  }
private buildInvoiceDetailsPayload(): any {
    const bacthDetails: any = {};
    if(this.batchData.code){
     bacthDetails['batchId'] = this.batchData?.code  
     if(this.fromPortInvoice){
      bacthDetails['systemSubType'] = this.batchData?.systemSubType || this.systemSubType;
     }

    }else{
    bacthDetails['nomination'] = this.batchData?.nominationNumber 
    bacthDetails['nominationKey'] = this.batchData?.nominationKey 
    bacthDetails['nominationKeyItem'] = this.batchData?.nominationItemNumber 
    if(this.fromPortInvoice){
    bacthDetails['systemSubType'] = this.batchData?.systemSubType || this.systemSubType;
    }
    }
    return bacthDetails;
  }

  detectMimeType(b64:any) {
    for (var s in this.signatures) {
      if (b64.indexOf(s) === 0) {
        return this.signatures[s];
      }
    }
  }
  transformDate(date:any){
    return moment(date).format('DD/MM/YYYY');
  }

  restrictDuplicateInvoices(action: boolean = false): void {
    const selectedType = this.selectedInvoiceType || '';
    const selectedOption = this.invoiceTypeOptions.find((option: any) =>
      selectedType === option?.value || selectedType.startsWith(option?.value || '')
    );
    const allowsMultiple =  selectedOption?.allowMultiple === 'true';

    if (this.selectedInvoiceType && this.portInvoiceAction === 'ADD' && !allowsMultiple) {
      let obj = { subtype: this.selectedInvoiceType };
      this.addedInvoices.push(obj);
      let duplicates: any[] = [];
      duplicates = this.addedInvoices.filter((item: any) => {
         return item.subtype.includes(this.selectedInvoiceType);
      });
      if (duplicates.length > 1) {
        this.toastrService.show('Duplicate invoice type selected: ' + this.selectedInvoiceType);
        return;
      }
    }
    this.saveInvoice(action);
  }
  submit(action: boolean = false): void{
    this.saveInvoice(action);
  }
}
